<template>
    <section class="py-20 bg-gradient-to-b from-[#E2C750] to-[#93802F]">
        <div class="container mx-auto px-4">
            <div class="flex items-center justify-between mb-12">
                <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-black">
                    Folgende <span class="text-white">Rohstoffe</span> analysieren<br />
                    wir für Sie
                </h2>
                <div class="hidden lg:block">
                    <i class="ph ph-stack text-[120px] text-black opacity-20"></i>
                </div>
            </div>

            <p class="text-lg md:text-xl mb-12 text-black font-semibold">
                Wählen Sie das Analysepaket passend zu Ihrem Marktinteresse und Ihrer Strategie.
            </p>

            <!-- Packages Grid -->
            <div class="flex flex-col gap-6">
                <!-- First Row: 3 packages -->
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div v-for="(pkg, index) in packages.slice(0, 3)" :key="index" class="bg-white rounded-2xl p-6 shadow-lg">
                        <div class="flex items-center gap-4 mb-6">
                            <img :src="$asset(pkg.icon, 'public')" :alt="pkg.name" class="w-[70px] h-[70px] object-contain" />
                            <h3 class="text-xl font-bold text-black flex-1">{{ pkg.name }}</h3>
                        </div>
                        <div class="flex gap-3">
                            <router-link
                                :to="pkg.link"
                                class="flex-1 px-4 py-3 rounded-full font-semibold text-white text-center transition hover:opacity-90"
                                :style="{ background: `linear-gradient(to top, ${buttonGradientTo}, ${buttonGradientFrom})` }"
                            >
                                Auswählen
                            </router-link>
                            <button class="bg-blue-dark text-white p-3 rounded-full hover:opacity-90 transition">
                                <i class="ph ph-info text-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Second Row: 2 packages centered -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto w-full">
                    <div v-for="(pkg, index) in packages.slice(3, 5)" :key="index + 3" class="bg-white rounded-2xl p-6 shadow-lg">
                        <div class="flex items-center gap-4 mb-6">
                            <img :src="$asset(pkg.icon, 'public')" :alt="pkg.name" class="w-[70px] h-[70px] object-contain" />
                            <h3 class="text-xl font-bold text-black flex-1">{{ pkg.name }}</h3>
                        </div>
                        <div class="flex gap-3">
                            <router-link
                                :to="pkg.link"
                                class="flex-1 px-4 py-3 rounded-full font-semibold text-white text-center transition hover:opacity-90"
                                :style="{ background: `linear-gradient(to top, ${buttonGradientTo}, ${buttonGradientFrom})` }"
                            >
                                Auswählen
                            </router-link>
                            <button class="bg-blue-dark text-white p-3 rounded-full hover:opacity-90 transition">
                                <i class="ph ph-info text-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    packages: {
        type: Array,
        default: () => []
    },
    buttonGradientFrom: {
        type: String,
        default: '#E2C750'
    },
    buttonGradientTo: {
        type: String,
        default: '#93802F'
    }
});
</script>
